import Vue from "vue"
import App from "@/App.vue"
import router from "@/router/Router"
import { Route } from "vue-router"
import store from "@/store/RootStore"
import { apiClient, bootstrapWithClientConfig } from "rp-components"
import "url-polyfill"

Vue.config.productionTip = false

router.beforeEach(async (to: Route, from: Route, next) => {
    const requiresAuth = to.meta?.requiresAuth ?? true
    if (to.path != "/public/login") {
        store.dispatch("login/setRefererRoute", to, { root: true })
    }
    if (to.path === "/public/login" && (await apiClient.hasToken())) {
        next({ path: "/public/properties" })
    } else if (!requiresAuth) {
        next()
    } else {
        if (await apiClient.hasToken()) {
            next()
        } else {
            next({ path: "/public/login" })
        }
    }
})

bootstrapWithClientConfig(() => {
    new Vue({
        router,
        store,
        render: (h) => h(App)
    }).$mount("#app")
})
